<ng-template #template>
    <div [class]="model.data.containerCss">
        <span [class]="model.data.additionalTitleCss">{{model.data.additionalTitle}}</span>
        <sv-action-bar-item-dropdown [model]="model"></sv-action-bar-item-dropdown>
    </div>
</ng-template>